import { render, staticRenderFns } from "./CDNCheckbox.vue?vue&type=template&id=931a98f4&scoped=true&"
import script from "./CDNCheckbox.vue?vue&type=script&lang=js&"
export * from "./CDNCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CDNCheckbox.vue?vue&type=style&index=0&id=931a98f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931a98f4",
  null
  
)

export default component.exports